import { render, staticRenderFns } from "./verifyMFA.vue?vue&type=template&id=c32c3830"
import script from "./verifyMFA.vue?vue&type=script&lang=js"
export * from "./verifyMFA.vue?vue&type=script&lang=js"
import style0 from "./verifyMFA.vue?vue&type=style&index=0&id=c32c3830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports